export const MODAL_WIDTH = '600px'
export const DEFAULT_SIZE_PAGINATION = 10
export const CUSTOM_CONTENT_PER_PAGE = 20
export const FORM_EDIT_ID = 'media-form-edit'
export const FORM_CREATE_ID = 'media-form-edit'
